import { authService } from '@/services/auth.js';

class DocsClient {
    async downloadDocument(documentId: string): Promise<Blob> {
        await authService.ensureValidToken();
        const res = await fetch(`/api/docs/v1/document/${documentId}/download`, {
            headers: { Authorization: `Bearer ${authService.getToken()!}` }
        });
        if (!res.ok) throw new Error(`Failed to download document: ${res.status}`);
        return res.blob();
    }
}

export const docsClient = new DocsClient();